import Rest from '@/services/Rest';

/**
 * @typedef {LeadService}
 */
export default class LeadService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/lead'
}